__turbopack_context__.v({
  "buttonContainer": "VariantSelectionBar-module__Lu5yuG__buttonContainer",
  "buyButton": "VariantSelectionBar-module__Lu5yuG__buyButton",
  "stickyBar": "VariantSelectionBar-module__Lu5yuG__stickyBar",
  "variantButton": "VariantSelectionBar-module__Lu5yuG__variantButton",
});
